import { useLocation, Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { selectLogin } from "../redux/Login/LoginSlice";
import { useContext } from "react";
import { PermissionContext } from "../context/PermissionContext";

export const RequiredPermission = ({ permission = [] }) => {

  // * AGREGAR OPCION DE PERMISO GLOBAL 'ROLE_ADMIN' CON LA CONDICION DE QUE TODO USUARIO CON ESTE ROL
  // * PUEDE ACCEDER A TODAS LAS RUTAS REGISTRADAS DEL SISTEMA.
  const permissionsValidate = [...permission, 'ROLE_ADMIN']

  // ? HOOK-LOCATION
  const location = useLocation();

  // ? HOOK-SELECTOR.
  const {accessToken} = useSelector(selectLogin);

  // ? EXTRAYENDO LOS DATOS DEL CONTEXT DE TODOS LOS PERMISOS EN BOOLEAN.
  const value = useContext(PermissionContext);

  // * DESESTRUCTURACION DE LOS DATOS.
  const { permisosState } = value.value;

  // * VALIDACION QUE COMPRUEBA QUE EXISTE UN PERMISO DEL USUARIO CON VALOR TRUE DENTRO DEL ARRAY DE PERMISOS
  // * QUE PUEDEN ACCEDER A LA RUTA PROTEGIDA.
  const accessPage = permissionsValidate.some(x => permisosState[x] === true);

  return accessPage ? 
    <Outlet />
      : accessToken !== null 
        ? 
            <Navigate to="/noAutorizado" state={{ from: location }} replace />
        : 
            <Navigate to="/login" state={{ from: location }} replace />  
};

export default RequiredPermission;
